<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditActivityConfigDialog(true, null)"
      >新增活动配置</el-button
    >
    <el-table :data="list" border size="small" style="width: 1541px">
      <el-table-column prop="id" label="配置ID" align="center" width="145">
      </el-table-column>

      <el-table-column
        prop="activityTemplateKey"
        label="类型"
        align="center"
        width="150"
      >
      </el-table-column>

      <el-table-column
        prop="startTimeType"
        label="开始时间类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ getStartTimeTypeLabel(scope.row.startTimeType) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="startTime"
        label="活动开始时间"
        align="center"
        width="120"
      >
      </el-table-column>

      <el-table-column
        prop="keepDays"
        label="活动持续时长（天）"
        align="center"
        width="130"
      >
      </el-table-column>

      <el-table-column
        prop="isCycle"
        label="循环开启"
        align="center"
        width="50"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isCycle ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cycleInterval"
        label="循环间隔"
        align="center"
        width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] != 0
                ? scope.row.cycleInterval[0] + "天"
                : ""
              : ""
          }}</span>
          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] != 0 ||
                scope.row.cycleInterval[1] != 0
                ? scope.row.cycleInterval[1] + "小时"
                : ""
              : ""
          }}</span>
          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] != 0 ||
                scope.row.cycleInterval[1] != 0 ||
                scope.row.cycleInterval[2] != 0
                ? scope.row.cycleInterval[2] + "分钟"
                : ""
              : ""
          }}</span>

          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] == 0 &&
                scope.row.cycleInterval[1] == 0 &&
                scope.row.cycleInterval[2] == 0
                ? "无缝衔接"
                : ""
              : ""
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="playType"
        label="玩法类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ getPlayTypeLabel(scope.row.playType) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isNoNextPlayWhenTimeNotEnough"
        label=""
        align="center"
        width="100"
      >
        <template slot="header">
          <span>若时间不够时不开启下一轮</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                若时间不够是否放弃开启下一轮玩法（仅当PlayType为1时有效）
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span v-if="!scope.row.isNoNextPlayWhenTimeNotEnough" style=""
            >否</span
          >
          <span
            v-if="scope.row.isNoNextPlayWhenTimeNotEnough"
            style="color: green"
            >是</span
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="playStartTime"
        label="玩法相距活动开始时间："
        align="center"
        width="160"
      >
        <template slot="header">
          <span>玩法相距活动开始时间：</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">从活动开启后开始计算，单位：分钟</div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ parseTimeStr(scope.row.playStartTime) }} </span>
        </template>
      </el-table-column>

      <el-table-column prop="playKeepTime" label="" align="center" width="150">
        <template slot="header">
          <span>玩法持续时长（分钟）</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                如果玩法持续时长为0，那么玩法默认持续到活动结束
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ parseTimeStr(scope.row.playKeepTime) }} </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="isGlobal"
        label="跨服活动"
        align="center"
        width="90"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.isGlobal" style="">否</span>
          <span v-if="scope.row.isGlobal" style="color: green">是</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="isEnabled"
        label="是否启用"
        align="center"
        width="70"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isEnabled" style="color: green">是</span>
          <span v-if="!scope.row.isEnabled" style="">否</span>
        </template>
      </el-table-column>
      <el-table-column label="自动启用" align="center" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.autoEnabledAfter != '0'">{{
            ms2ymdhm(scope.row.autoEnabledAfter)
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="childActivities"
        label="子活动集合"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.childActivities" :key="index">
            {{ getChildActivityLabel(item.id) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <span
            class="link-button"
            style="color: red"
            @click="remove(scope.row)"
            >删除</span
          >
          <span
            class="link-button"
            style="color: red"
            @click="settlement(scope.row)"
            >结算活动</span
          >
          <span
            class="link-button"
            @click="openEditActivityConfigDialog(false, scope.row)"
            >编辑</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const yaml = require("js-yaml");

export default {
  data() {
    return {
      list: [], // 活动配置列表
      param: {},
    };
  },

  async created() {
    this.loadList();
    await this.loadParam();
  },

  components: {},

  methods: {
    async loadParam() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getActivityConfigParam`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.param = resData.data;
    },
    /**
     * 拉取活动配置集合
     */
    async loadList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAllActivityConfig`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = listInResponse;
    },

    /**
     * 删除
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除活动配置（${entry.id}）？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delActivityConfig`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (error) {}
    },

    /**
     * 结算活动
     */
    async settlement(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认立即结算活动配置（${entry.id}）的所有正在运行的活动？`
        );

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/settlementActivitiesByConfId`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (error) {}
    },

    /**
     * 打开活动配置编辑框
     */
    async openEditActivityConfigDialog(isCreated, entry) {
      this.$dialogutil.open("EditActivityConfigDialog", {
        closedCallback: () => {
          setTimeout(async () => {
            await this.loadList();
          }, 2000);
        },
        data: { isCreated: isCreated, entry: entry },
      });
    },

    getChildActivityLabel(val) {
      for (let item of this.param.childActivities) {
        if (item.value == val) {
          return item.label;
        }
      }

      return "";
    },
    getPlayTypeLabel(val) {
      for (let item of this.param.playTypes) {
        if (item.value == val) {
          return item.label;
        }
      }

      return "";
    },
    getStartTimeTypeLabel(val) {
      for (let item of this.param.startTimeTypes) {
        if (item.value == val) {
          return item.label;
        }
      }

      return "";
    },

    parseTimeStr(val) {
      let timeStr = "";
      let minute = 0;
      if (val > 0) {
        minute = val % 60;
      } else {
        return timeStr;
      }
      timeStr = (minute < 10 ? +minute : minute) + "分钟" + timeStr;

      val = parseInt(val / 60);
      let hour = 0;
      if (val > 0) {
        hour = val % 24;
      } else {
        return timeStr;
      }
      timeStr = (hour < 10 ? hour : hour) + "小时" + timeStr;

      val = parseInt(val / 24);
      let day = 0;
      if (val > 0) {
        day = val % 24;
      } else {
        return timeStr;
      }
      timeStr = day + "天" + timeStr;

      return timeStr;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    string2yaml(obj) {
      let yamlStr;
      yaml.loadAll(obj, function (doc) {
        yamlStr = yaml.dump(doc, {
          styles: {
            "!!null": "canonical",
          },
          sortKeys: true,
        });
      });
      return yamlStr;
    },
    formatCode(obj) {
      return JSON.stringify(obj, null, "    ");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>

  